import DOMPurify from 'dompurify';
import { useIntl } from 'react-intl';
import { FarmService } from 'types/FarmData';

interface FarmDescriptionProps {
  description?: string;
  services?: FarmService[];
}

const FarmDescription = ({ description, services }: FarmDescriptionProps) => {
  const intl = useIntl();
  const visibleServices = services?.filter((service) => !service.hidden) ?? [];

  return (
    <div className={'farm-description'}>
      {!!description && (
        <div
          className={'farm-description-text'}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
        />
      )}
      {!!visibleServices.length && (
        <>
          {!!description && <hr className={'farm-divider'} />}
          <div className={'farm-services'}>
            <p className={'farm-services-label'}>
              {intl.formatMessage({ id: 'farm_view.we_offer' })}
            </p>
            <div className={'farm-services-tags'}>
              {visibleServices.map((service) => (
                <span key={service.id} className={'farm-service-tag'}>
                  {service.name}
                </span>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FarmDescription;
